import qs from 'query-string';
import { get } from './baseApi';

export const BullApi = {
    fetch: (query, options) => get(`/bulls?${qs.stringify(query)}`, options),
};
